import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import ButtonCreateFolder from './button-create-folder';

const useStyles = makeStyles((theme) => ({
    searchGroup: {
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    TitileName:{
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: "500",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal"
    }
}));

function Index({ name, setSnackbarMessage, categoryId, getCategory, pickerMode, permission }) {
    const classes = useStyles();

    return (
        <Box display='flex' className={classes.searchGroup}>
            <Box flexGrow={1}> <Typography className={classes.TitileName}>{name}</Typography></Box>
            {
                (!pickerMode && permission.isCreate) &&
                <ButtonCreateFolder
                    categoryId={categoryId}
                    getCategory={getCategory}
                    setSnackbarMessage={setSnackbarMessage}
                />
            }

        </Box>
    );
}

Index.propTypes = {
    categoryId: PropTypes.number,
    setSnackbarMessage: PropTypes.func.isRequired,
    getCategory: PropTypes.func.isRequired,
};

export default Index;
